"use strict";

var _a;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loggerTheme = void 0;
var loggerPaletteName_1 = require("../enums/loggerPaletteName");
/**
 * https://github.com/chriskempson/tomorrow-theme#tomorrow-night-eighties
 */
exports.loggerTheme = (_a = {}, _a[loggerPaletteName_1.LoggerPaletteName.NightEighties] = {
  Background: '#2D2D2D',
  CurrentLine: '#393939',
  Selection: '#515151',
  Foreground: '#CCCCCC',
  Comment: '#999999',
  Red: '#F2777A',
  Orange: '#F99157',
  Yellow: '#FFCC66',
  Green: '#99CC99',
  Aqua: '#66CCCC',
  Blue: '#6699CC',
  Purple: '#CC99CC'
}, _a[loggerPaletteName_1.LoggerPaletteName.TomorrowNight] = {
  Background: '#1D1F21',
  CurrentLine: '#282A2E',
  Selection: '#373B41',
  Foreground: '#C5C8C6',
  Comment: '#969896',
  Red: '#CC6666',
  Orange: '#DE935F',
  Yellow: '#F0C674',
  Green: '#B5BD68',
  Aqua: '#8ABEB7',
  Blue: '#81A2BE',
  Purple: '#B294BB'
}, _a[loggerPaletteName_1.LoggerPaletteName.Tomorrow] = {
  Background: '#FFFFFF',
  CurrentLine: '#EFEFEF',
  Selection: '#D6D6D6',
  Foreground: '#4D4D4C',
  Comment: '#8E908C',
  Red: '#C82829',
  Orange: '#F5871F',
  Yellow: '#EAB700',
  Green: '#718C00',
  Aqua: '#3E999F',
  Blue: '#4271AE',
  Purple: '#8959A8'
}, _a[loggerPaletteName_1.LoggerPaletteName.TomorrowNightBlue] = {
  Background: '#002451',
  CurrentLine: '#00346E',
  Selection: '#003F8E',
  Foreground: '#FFFFFF',
  Comment: '#7285B7',
  Red: '#FF9DA4',
  Orange: '#FFC58F',
  Yellow: '#FFEEAD',
  Green: '#D1F1A9',
  Aqua: '#99FFFF',
  Blue: '#BBDAFF',
  Purple: '#EBBBFF'
}, _a[loggerPaletteName_1.LoggerPaletteName.TomorrowNightBright] = {
  Background: '#000000',
  CurrentLine: '#2A2A2A',
  Selection: '#424242',
  Foreground: '#EAEAEA',
  Comment: '#969896',
  Red: '#D54E53',
  Orange: '#E78C45',
  Yellow: '#E7C547',
  Green: '#B9CA4A',
  Aqua: '#70C0B1',
  Blue: '#7AA6DA',
  Purple: '#C397D8'
}, _a);